//#professional-solutions > div.wrapper > div.page > header > div.header-container.type3.header-color-custom.header-sticky-color-custom.header-menu-style-default_new.menu-color-custom.sticky-menu-color-custom.header-menu-left > div.header.container > div.header-left > div.main-nav.wrapper-top-menu > div > div > nav > ul > li.tmenu_item.tmenu_item--root.tmenu_item_level_0.tmenu_item_submenu_type_tab.tmenu_item_submenu_mega_position_fullwidth.tmenu_item_has_child > div > ul > li.tmenu_submenu_tab_active

/*$(function() {
  
  $(".tmenu_item_has_child").hover(
    function() {
      $(".tmenu_item_has_child:hover .tmenu_submenu_tab_control:first-child > li").removeClass("tmenu_submenu_tab_active");
      $(".tmenu_item_has_child:hover .tmenu_submenu_tab_control:first-child > li:first-child").first().addClass("tmenu_submenu_tab_active products-menu-blue");
      //             $(".tmenu_item_has_child:hover .tmenu_submenu_tab_control:first-child > li:first-child> a").first().css("color", "#246b9c !important");
      console.log('products hover added');
    },
    function() {
      $(".tmenu_item_has_child:hover .tmenu_submenu_tab_control:first-child > li").removeClass("tmenu_submenu_tab_active");
    }
  );
  */

  
  $(function () {

   let previousScroll = 0;
    let scroll = $(document).scrollTop();
    let p = $( ".__pf .pf-29_" ).first();
	let position = p.position();
    console.log(position);
  
    $(window).scroll(function () {
      let currentScroll = $(this).scrollTop();
      let scrolled = $(document).scrollTop();

        if (currentScroll > previousScroll) {
          	// on scroll down             
          	hideMainNav();                             
           	showProductBarOnTop();
          	showShopBarOnTop();
         
                  
        } else {
          	// on scroll up
           showMainNav();                   	
           showProductBarBellowNavigation();
           showShopBarBellowNavigation();
          
        }
            	      
         previousScroll = currentScroll;      	
    });
    
    const mediaQuery = window.matchMedia('(max-width: 991px)');
    
    if (mediaQuery.matches) {
  	  $(window).scroll(function () {
      let currentScroll = $(this).scrollTop();
      let scrolled = $(document).scrollTop();

        if (currentScroll > previousScroll) {
          	// on scroll down             
          //	hideMain();                             
          // 	showProductBarOnTop991();
         // 	showShopBarOnTop991();
                  
        } else {
          	// on scroll up
           showMainNav();                   	
           showProductBarBellowNavigation991();
           showShopBarBellowNavigationMedia991();
          
        }
            	      
         previousScroll = currentScroll;      	
    });
    }
  
    function hideMainNav() {    
        $(".main-section-header").addClass('animate'); 
  	}
  
  	function showMainNav() {
    	 $(".main-section-header").removeClass('animate');
  	}
        
    function showProductBarOnTop() {
       if ( $(".cstm-product-nav.affix").hasClass('sticky_product')) {
        $(".cstm-product-nav.affix").removeClass('sticky_product');
      }
     $(".cstm-product-nav.affix").addClass('animate_product');   
  	}
        
  
  	function showProductBarBellowNavigation() {
      if ( $(".cstm-product-nav.affix").hasClass('animate_product')) {
        $(".cstm-product-nav.affix").removeClass('animate_product');
      }
            
       $(".cstm-product-nav.affix").addClass('sticky_product');   
  	}
    
    function showProductBarBellowNavigation991() {
     
            
       $(".cstm-product-nav.affix").addClass('sticky_product_991');   
  	}
        
    function showShopBarOnTop() {
       if ( $(".__pf .pf-29_").hasClass('sticky_shop')) {
        $(".__pf .pf-29_").removeClass('sticky_shop');
      }
     $(".__pf .pf-29_").removeClass('animate_shop');   
  	}
    
     function showShopBarBellowNavigation() {
       if ( $(".__pf .pf-29_").hasClass('animate_shop')) {
        $(".__pf .pf-29_").removeClass('animate_shop');
      }
     $(".__pf .pf-29_").removeClass('sticky_shop');   
  	}
         
    function showShopBarBellowNavigationMedia991() {
         
        $(".__pf .pf-29_").removeClass('animate_shop');                
      	$(".__pf .pf-29_").removeClass('sticky_shop');
         
        $(".__pf .pf-29_").removeClass('sticky_shop_991');   
  	}
    
    
  
});